module.exports = __webpack_public_path__ + "img/10.2161a0b0.jpg";